import { useRef } from "react";
import { isDeepEqual } from "remeda";

/* eslint-disable react-hooks/refs */

/**
 * Similar to `useMemo`, except it uses deep equality to compare the dependencies.
 *
 * Dependencies does not have to be an array.
 */
export function useDeepEqualMemo<T>(get: () => T, deps: unknown[] | object): T {
    const previousDepsRef = useRef<typeof deps | undefined>(undefined);
    const resultRef = useRef<T | undefined>(undefined);

    if (!isDeepEqual(previousDepsRef.current, deps)) {
        previousDepsRef.current = deps;
        resultRef.current = get();
    }

    return resultRef.current!;
}
